import { useTenant } from '@emerald-works-nova/auth'
import { useMemo } from 'react'
import useGroup from './useGroup'
import { CONSUMER, ADMIN } from '../services/cognito/userGroups'
import consts from '../consts'

const usePaidConsumer = () => {
  const tenant = useTenant()
  const isClub = tenant.pk === consts.DEFAULT_CLUB_PK

  const { isInGroup } = useGroup()
  const shouldSeePaidConsumerHome = isInGroup([CONSUMER, ADMIN])

  const isPaidConsumer = useMemo(() => {
    return shouldSeePaidConsumerHome && isClub
  }, [isClub, shouldSeePaidConsumerHome])

  return {
    isPaidConsumer
  }
}

export default usePaidConsumer
